const COMPARE_STORAGE_KEY = 'sw_compare_products';
const COMPARE_MAX = 5;
function loadFromStorage() {
    try {
        const stored = localStorage.getItem(COMPARE_STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
    }
    catch {
        return [];
    }
}
function persist(items) {
    try {
        localStorage.setItem(COMPARE_STORAGE_KEY, JSON.stringify(items));
    }
    catch { }
}
export function registerCompare() {
    const store = {
        items: loadFromStorage(),
        get count() {
            return this.items.length;
        },
        get isFull() {
            return this.items.length >= COMPARE_MAX;
        },
        get ids() {
            return this.items.map(i => i.id);
        },
        has(id) {
            return this.items.some(item => item.id === id);
        },
        add(id, name, image = '') {
            if (this.has(id) || this.isFull)
                return;
            this.items.push({ id, name, image });
            persist(this.items);
        },
        remove(id) {
            this.items = this.items.filter(item => item.id !== id);
            persist(this.items);
        },
        toggle(id, name, image = '') {
            this.has(id) ? this.remove(id) : this.add(id, name, image);
        },
        clear() {
            this.items = [];
            persist([]);
        },
    };
    window.Alpine.store('compare', store);
    window.compareCheckbox = (productId, productName, productImage = '') => ({
        productId,
        productName,
        productImage,
        get isChecked() {
            return this.$store.compare.has(this.productId);
        },
        toggle() {
            ;
            this.$store.compare.toggle(this.productId, this.productName, this.productImage);
        },
    });
    window.compareFlag = () => ({
        expanded: false,
        get compareUrl() {
            const ids = this.$store.compare.ids;
            const params = ids.map((id) => `ids[]=${encodeURIComponent(id)}`).join('&');
            return `/vergleich?${params}`;
        },
    });
    if (typeof window !== 'undefined' && window.location.pathname === '/vergleich') {
        const hasIdsInUrl = window.location.search.includes('ids[');
        if (!hasIdsInUrl) {
            document.addEventListener('alpine:initialized', () => {
                const ids = window.Alpine?.store('compare')?.ids ?? [];
                if (ids.length >= 2) {
                    const params = ids.map((id) => `ids[]=${encodeURIComponent(id)}`).join('&');
                    window.location.replace(`/vergleich?${params}`);
                }
            });
        }
    }
}
